import { getCarrierInitials, getCarrierLogoUrl } from "@/lib/carrier-logos";
import { cn } from "@/lib/utils";

type CarrierLogoProps = {
  code?: string | null;
  name?: string | null;
  className?: string;
  imageClassName?: string;
};

export function CarrierLogo({ code, name, className, imageClassName }: CarrierLogoProps) {
  const logoUrl = getCarrierLogoUrl(code, name);
  const label = name || code || "Carrier";

  return (
    <span
      className={cn(
        "grid size-8 shrink-0 place-items-center overflow-hidden rounded-lg bg-white shadow-[inset_0_0_0_1px_rgba(0,0,0,0.10)] dark:bg-white dark:shadow-[inset_0_0_0_1px_rgba(255,255,255,0.10)]",
        className,
      )}
      title={label}
    >
      {logoUrl ? (
        <img
          src={logoUrl}
          alt=""
          aria-hidden="true"
          loading="lazy"
          className={cn("h-full w-full object-contain p-1.5", imageClassName)}
        />
      ) : (
        <span className="flex h-full w-full items-center justify-center bg-muted px-1 text-center font-mono text-[10px] font-bold text-muted-foreground dark:bg-muted">
          {getCarrierInitials(code, name)}
        </span>
      )}
    </span>
  );
}
